import type React from 'react';

import { Select } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useScope } from './hooks/useScope';

export const Scope: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = useScope();

	return (
		<div id="petition_geo_reach" className="mt-4 flex flex-col">
			<Select
				id="scope-select"
				name="scope-select"
				size="large"
				errorMessage={data.error}
				onSelectionChange={actions.onSelectionChange}
				label={translate('corgi.petition.edit.petition_data.scope.title')}
				data-qa="scope-select"
				selectedKey={data.value}
				defaultSelectedKey={data.value}
				placeholder={translate('corgi.petition.edit.petition_data.scope.placeholder')}
				items={data.scopeKeys.map((key) => ({
					id: key,
					name: key,
					label: translate(`corgi.petition.edit.petition_data.scope.${key}`),
				}))}
				className="[&_.react-aria-Label_span]:text-size-body-small"
			/>
		</div>
	);
};
